import styled, { keyframes } from 'styled-components';

import { Placeholder, Spacing } from '../../theme';
import { rem } from '../../utils';

export const placeholderSize: Record<
  string,
  {
    width: string;
    height: string;
    gap: string;
  }
> = {
  Small: {
    width: '100%',
    height: rem(Placeholder.Size.Small),
    gap: rem(Spacing.Size.XXSmall),
  },

  Medium: {
    width: '100%',
    height: rem(Placeholder.Size.Medium),
    gap: rem(Spacing.Size.Medium),
  },
};

export type PlaceholderHolderSize = keyof typeof placeholderSize;

export const placeholderShimmerKeyframe = keyframes`
  0% {
    background-position: ${rem(-1000)} 0;
  }
  100% {
    background-position: ${rem(1000)} 0;
  }
`;

export const StyledWrapper = styled.div<{ size: PlaceholderHolderSize }>`
  display: flex;
  flex-flow: column;
  width: 100%;
  gap: ${({ size }) => placeholderSize[size]?.gap ?? placeholderSize.Medium.gap};
`;

export const StyledPlaceholder = styled.div<{ size: PlaceholderHolderSize }>`
  width: ${placeholderSize.Medium.width};

  height: ${({ size }) => placeholderSize[size]?.height ?? placeholderSize.Medium};

  background: ${({ theme }) =>
    `linear-gradient(
      to right,
     ${theme.Color.Neutrals.Light} 5%,
     rgba(0, 0, 0, 0.06) 35%,
     ${theme.Color.Neutrals.Light} 65%
    )`};
  border-radius: ${({ theme }) => theme.Border.Radius.Medium}px;
  animation: ${placeholderShimmerKeyframe} 1.4s linear 0s infinite normal forwards;
  background-size: ${rem(1000)} 100%;
`;
